<template>
  <div>
    <div v-if="params.data && params.data.warning && params.data.warning.message">
      <v-tooltip right color="primary">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-icon class="pr-3 red--text"> mdi-information </v-icon>
          </div>
        </template>
        <span class="text-capitalize">{{ params.data.warning.message }}</span>
      </v-tooltip>
    </div>
  </div>
</template>
<script>
export default {};
</script>
